import { loadAndTrack } from "redux-request-loading";
import { Dispatch } from "redux";

import { questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";
import { Questionnaire } from "@teamprevent/common/questionnaires/model";
import { PHYSIOTHERAPY_REFERRAL_REPORT_KEY } from "@teamprevent/common/physiotherapyReferralReport/models";

import { physiotherapyReferralReportApi } from "./physiotherapyReferralReportApi";
import * as actions from "./actionTypes";

export const loadPhysiotherapyReferralReportByViewTaskId = ({ ohCaseId, viewReportTaskId }: { ohCaseId: string; viewReportTaskId: string }) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack<Questionnaire>(
            dispatch,
            actions.LOAD_PHYSIOTHERAPY_REFERRAL_REPORT,
            physiotherapyReferralReportApi.getByViewTaskId(ohCaseId, viewReportTaskId)
        );
        dispatch(questionnaireLoaded({
            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
            questions: result.data.questions,
            eTag: result.eTag,
            isDefaultCustomerType: result.isDefaultCustomerType,
            customerType: result.customerType }));

        await loadAndTrack(dispatch, actions.VIEWED_PHYSIOTHERAPY_REFERRAL_REPORT, physiotherapyReferralReportApi.view(ohCaseId, viewReportTaskId));
    };
};

export const loadPhysiotherapyReferralReportByWriteTaskId = ({ ohCaseId, writeReportTaskId }: { ohCaseId: string; writeReportTaskId: string }) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack<Questionnaire>(
            dispatch,
            actions.LOAD_PHYSIOTHERAPY_REFERRAL_REPORT,
            physiotherapyReferralReportApi.getByWriteTaskId(ohCaseId, writeReportTaskId)
        );
        dispatch(questionnaireLoaded({
            questionnaireKey: PHYSIOTHERAPY_REFERRAL_REPORT_KEY,
            questions: result.data.questions,
            eTag: result.eTag,
            isDefaultCustomerType: result.isDefaultCustomerType,
            customerType: result.customerType }));
    };
};
